(function () {
  "use strict";
  var root = document.getElementById("used-board");
  if (!root) return;

  // ---------- Copy and configuration ----------
  var T = {};
  try { T = JSON.parse((root.querySelector("[data-used-i18n]") || {}).textContent || "{}"); } catch (_e) { T = {}; }
  function t(key, vars) {
    var text = Object.prototype.hasOwnProperty.call(T, key) ? T[key] : key;
    if (vars) Object.keys(vars).forEach(function (name) { text = text.split("{" + name + "}").join(String(vars[name])); });
    return text;
  }
  function attr(name, fallback) { return root.getAttribute(name) || fallback || ""; }
  var cfg = {
    api: attr("data-api").replace(/\/$/, ""),
    lang: attr("data-lang", "en"),
    localeTag: attr("data-locale-tag", "en"),
    currency: /^(EUR|GBP|AUD|NZD)$/.test(attr("data-currency")) ? attr("data-currency") : "EUR",
    region: attr("data-region", "EU"),
    regionName: attr("data-region-name", "Speediance"),
    orderExample: attr("data-order-example", "#12345"),
    warrantyUrl: sameOrigin(attr("data-warranty-url"), "/pages/warranty"),
    privacyUrl: sameOrigin(attr("data-privacy-url"), "/policies/privacy-policy"),
    careUrl: /^https:\/\/support\.speediance\.(eu|co\.uk|com\.au|nz)$/.test(attr("data-care-url")) ? attr("data-care-url") : "",
    gm3Url: sameOrigin(attr("data-gm3-url"), "/products/speediance-gym-monster-3"),
    ultraUrl: sameOrigin(attr("data-ultra-url"), "/products/speediance-gym-monster-ultra"),
  };
  var FILTERS = ["model", "warranty", "condition", "city", "price_min", "price_max", "sort"];
  var AGREEMENT_KEYS = { buyer: ["private_sale", "inspection", "transport", "terms"], seller: ["private_seller", "condition", "transport", "terms"] };
  var CATEGORIES = ["whole_unit", "screen", "accessories", "wear"];
  var FILTER_THRESHOLD = 6;

  var grid = root.querySelector("[data-used-grid]");
  if (!grid) return;
  var count = root.querySelector("[data-used-count]");
  var notice = root.querySelector("[data-used-notice]");
  var empty = root.querySelector("[data-used-empty]");
  var toolbar = root.querySelector("[data-used-toolbar]");
  var filterToggle = root.querySelector("[data-used-filter-toggle]");
  var detail = root.querySelector("[data-used-detail]");
  var detailBody = root.querySelector("[data-used-detail-body]");
  var sellDialog = root.querySelector("[data-used-sell-dialog]");
  var sellBody = root.querySelector("[data-used-sell-body]");
  var manageDialog = root.querySelector("[data-used-manage-dialog]");
  var manageBody = root.querySelector("[data-used-manage-body]");
  var termsDialog = root.querySelector("[data-used-terms-dialog]");
  var termsBody = root.querySelector("[data-used-terms-body]");
  var cityInput = root.querySelector("[data-used-city]");
  var sortSelect = root.querySelector("[data-used-sort]");
  var conditionSelect = root.querySelector("[data-used-condition]");
  var priceMin = root.querySelector("[data-used-price-min]");
  var priceMax = root.querySelector("[data-used-price-max]");

  var terms = null, termsError = false, termsRequest = null;
  var state = { listings: [], total: 0, models: [], query: readQuery(), loading: true, error: false };
  var listRequest = 0, detailRequest = 0, filterTimer = 0, filtersOpen = false;
  // One verified order session (from a code) serves both listing and managing.
  var session = { token: "", expiresAt: 0, orderNumber: "" };
  var manageToken = "";
  try { manageToken = window.__usedManageToken || ""; window.__usedManageToken = ""; } catch (_e) { manageToken = ""; }

  // ---------- Helpers ----------
  function sameOrigin(value, fallback) {
    try {
      var url = new URL(value || fallback, window.location.href);
      if (url.origin === window.location.origin) return url.pathname;
    } catch (_e) { /* fall through */ }
    return fallback;
  }
  function esc(value) {
    return String(value == null ? "" : value).replace(/[&<>"']/g, function (ch) {
      return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[ch];
    });
  }
  function safeSrc(value) {
    if (typeof value !== "string") return "";
    try {
      var url = new URL(value);
      var photo = url.origin === "https://pipeline.futuremvmt.com" && /^\/dashboard-api\/api\/public\/warranty\/photos\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(url.pathname) && !url.search && !url.hash;
      return url.protocol === "https:" && (url.hostname === "cdn.shopify.com" || photo) && !url.username && !url.password ? url.href : "";
    } catch (_e) { return ""; }
  }
  function money(amount, unit) {
    try {
      return new Intl.NumberFormat(cfg.localeTag, { style: "currency", currency: unit || cfg.currency, currencyDisplay: "narrowSymbol", maximumFractionDigits: 0 }).format(amount);
    } catch (_e) {
      try { return new Intl.NumberFormat(cfg.localeTag, { style: "currency", currency: unit || cfg.currency, maximumFractionDigits: 0 }).format(amount); }
      catch (_e2) { return (unit || cfg.currency) + " " + amount; }
    }
  }
  function conditionLabel(value) { return ["excellent", "good", "fair"].indexOf(value) !== -1 ? t("cond_" + value) : ""; }
  function reasonLabel(value) { return value === "upgrade_gm3" ? t("reason_gm3") : value === "upgrade_ultra" ? t("reason_ultra") : ""; }
  function reasonUrl(value) { return value === "upgrade_gm3" ? cfg.gm3Url : value === "upgrade_ultra" ? cfg.ultraUrl : ""; }
  function warrantyText(item) {
    var warranty = item && item.warranty;
    if (!warranty || warranty.status === "unknown" || warranty.status === "unpublished") return t("warranty_unknown");
    if (warranty.status === "out_of_warranty" || !warranty.in_warranty) return t("out_of_warranty");
    var days = Number(warranty.remaining_days);
    if (!Number.isFinite(days) || days <= 0) return t("out_of_warranty");
    if (days >= 30) { var months = Math.max(1, Math.round(days / 30)); return months === 1 ? t("month") : t("months", { n: months }); }
    return t("days", { n: days });
  }
  function track(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: "used_marketplace_" + name, used_region: cfg.region }, data || {})); } catch (_e) { /* analytics is optional */ }
    try { if (typeof window.fbq === "function") window.fbq("trackCustom", "UsedMarketplace_" + name, Object.assign({ region: cfg.region }, data || {})); } catch (_e) { /* analytics is optional */ }
  }
  function pageUrl(params) {
    var url = new URL(window.location.href);
    url.hash = "";
    ["sell", "manage", "code"].forEach(function (key) { url.searchParams.delete(key); });
    Object.keys(params || {}).forEach(function (key) { if (params[key]) url.searchParams.set(key, params[key]); });
    return url.pathname + url.search;
  }

  function json(path, options) {
    var opts = options || {};
    var headers = {};
    if (opts.body) headers["Content-Type"] = "application/json";
    if (opts.auth) headers.Authorization = opts.auth;
    var controller = typeof AbortController !== "undefined" ? new AbortController() : null;
    var timer = controller ? window.setTimeout(function () { controller.abort(); }, opts.timeoutMs || 20000) : 0;
    return fetch(cfg.api + path, {
      method: opts.method || "GET", credentials: "omit", headers: headers,
      signal: controller ? controller.signal : undefined,
      body: opts.body ? JSON.stringify(opts.body) : undefined,
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (body) {
        if (!res.ok || !body || body.ok !== true) {
          var error = new Error(body && body.error || "Request failed");
          error.status = res.status; error.code = body && body.code; error.body = body;
          throw error;
        }
        return body;
      });
    }).finally(function () { window.clearTimeout(timer); });
  }
  // Server messages are English. Show them on English pages; elsewhere use the
  // translated message for the kind of problem.
  function problem(error, fallbackKey) {
    if (error && error.status === 429) return t("too_many");
    if (error && error.code === "LISTING_CONTENT") return cfg.lang === "en" && error.message ? error.message : t("content_refused");
    if (error && (error.code === "LISTING_CHECK_UNAVAILABLE" || error.code === "MEDIA_UNAVAILABLE")) return t("checks_down");
    if (error && error.status >= 400 && error.status < 500 && cfg.lang === "en" && error.message && error.message !== "Request failed") return error.message;
    return t(fallbackKey);
  }
  function sessionLive() { return !!session.token && Date.now() < session.expiresAt; }
  function bearer() { return "Bearer " + session.token; }

  // ---------- Dialogs ----------
  function openSheet(dialog) {
    if (!dialog) return;
    window.clearTimeout(dialog._usedCloseTimer);
    if (!dialog.open) dialog.showModal();
    requestAnimationFrame(function () { if (dialog.open) dialog.classList.add("is-open"); });
  }
  // A reload after closing the sell sheet should not reopen it.
  function clearSellAddress() {
    var url = new URL(window.location.href), changed = false;
    if (url.hash.toLowerCase() === "#sell") { url.hash = ""; changed = true; }
    if (url.searchParams.get("sell") === "1") { url.searchParams.delete("sell"); changed = true; }
    if (changed) window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
  }
  function closeSheet(dialog) {
    if (!dialog) return;
    if (dialog === sellDialog) clearSellAddress();
    dialog.classList.remove("is-open");
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.clearTimeout(dialog._usedCloseTimer);
    dialog._usedCloseTimer = window.setTimeout(function () { if (dialog.open) dialog.close(); }, reduce ? 0 : 220);
  }
  function closeButton() { return '<button type="button" class="used-board__dismiss" data-used-close aria-label="' + esc(t("close")) + '">×</button>'; }
  [detail, sellDialog, manageDialog, termsDialog].forEach(function (dialog) {
    if (!dialog) return;
    dialog.addEventListener("click", function (event) {
      if (event.target === dialog || event.target.closest("[data-used-close]")) { if (dialog === detail) closeDetail(); else closeSheet(dialog); }
    });
    dialog.addEventListener("cancel", function (event) { event.preventDefault(); if (dialog === detail) closeDetail(); else closeSheet(dialog); });
  });

  // ---------- Terms ----------
  function validTerms(body) {
    return body && typeof body.version === "string" && body.region === cfg.region && Array.isArray(body.sections) && body.sections.length > 0 &&
      body.sections.every(function (section) { return section && typeof section.title === "string" && typeof section.body === "string"; }) &&
      body.acknowledgements && Object.keys(AGREEMENT_KEYS).every(function (role) {
        return body.acknowledgements[role] && AGREEMENT_KEYS[role].every(function (key) { return typeof body.acknowledgements[role][key] === "string" && body.acknowledgements[role][key].trim(); });
      });
  }
  function loadTerms() {
    if (termsRequest) return termsRequest;
    termsError = false;
    termsRequest = json("/terms?locale=" + encodeURIComponent(cfg.lang)).then(function (body) {
      if (!validTerms(body)) throw new Error("Invalid terms");
      terms = body;
    }).catch(function () { termsError = true; }).finally(function () { termsRequest = null; renderTerms(); });
    return termsRequest;
  }
  function renderTerms() {
    if (termsBody) {
      termsBody.innerHTML = terms ? '<p class="used-board__small">' + esc(t("terms_version", { v: terms.version })) + '</p>' + terms.sections.map(function (section) {
        return '<section><h3>' + esc(section.title) + '</h3><p>' + esc(section.body) + '</p></section>';
      }).join("") + '<p><a href="' + esc(cfg.privacyUrl) + '">' + esc(t("privacy")) + '</a></p>' : termsStatus();
    }
    root.querySelectorAll("[data-used-agreements]").forEach(renderAgreementGroup);
  }
  function termsStatus() {
    return '<p role="status">' + esc(termsError ? t("terms_error") : t("terms_loading")) + '</p>' + (termsError ? '<button type="button" class="used-board__inline-btn" data-used-terms-retry>' + esc(t("terms_retry")) + '</button>' : "");
  }
  function agreementsMarkup(role, legendKey) {
    return '<fieldset class="used-board__agreements" data-used-agreements="' + role + '"><legend>' + esc(t(legendKey)) + '</legend><div data-used-agreement-fields></div></fieldset>';
  }
  function renderAgreementGroup(group) {
    var role = group.getAttribute("data-used-agreements");
    var fields = group.querySelector("[data-used-agreement-fields]");
    if (!fields || !AGREEMENT_KEYS[role]) return;
    // Keep ticks across a re-render only while the wording is unchanged.
    var checked = {};
    if (terms && group._termsKey === terms.version + ":" + terms.locale) fields.querySelectorAll("input[type=checkbox]").forEach(function (input) { checked[input.name] = input.checked; });
    group._termsKey = terms ? terms.version + ":" + terms.locale : "";
    fields.innerHTML = terms ? AGREEMENT_KEYS[role].map(function (key) {
      return '<label class="used-board__agreement"><input type="checkbox" name="agree_' + key + '"' + (checked["agree_" + key] ? " checked" : "") + '><span>' + esc(terms.acknowledgements[role][key]) + '</span></label>';
    }).join("") + '<p class="used-board__small"><button type="button" class="used-board__inline-btn" data-used-terms-link>' + esc(t("read_terms")) + '</button></p>' : termsStatus();
    var form = group.closest("form");
    if (form) syncSubmit(form);
  }
  function readAgreements(form, role) {
    if (!terms) return null;
    var result = { version: terms.version, locale: terms.locale || cfg.lang };
    for (var i = 0; i < AGREEMENT_KEYS[role].length; i += 1) {
      var input = form.querySelector('input[name="agree_' + AGREEMENT_KEYS[role][i] + '"]');
      if (!input || !input.checked) { if (input) input.focus(); return null; }
      result[AGREEMENT_KEYS[role][i]] = true;
    }
    return result;
  }
  function openTerms() {
    if (!terms && !termsRequest) loadTerms();
    renderTerms();
    openSheet(termsDialog);
  }

  // ---------- Busy state ----------
  function setBusy(form, busy, label) {
    if (!form) return;
    form.setAttribute("aria-busy", busy ? "true" : "false");
    form.querySelectorAll('button[type="submit"]').forEach(function (button) {
      if (busy) { if (!button.hasAttribute("data-idle")) button.setAttribute("data-idle", button.textContent); button.textContent = label || button.textContent; }
      else if (button.hasAttribute("data-idle")) { button.textContent = button.getAttribute("data-idle"); button.removeAttribute("data-idle"); }
    });
    syncSubmit(form);
  }
  function isBusy(form) { return !!form && form.getAttribute("aria-busy") === "true"; }
  function syncSubmit(form) {
    var needsTerms = !!form.querySelector("[data-used-agreements]");
    var uploading = form._photos ? form._photos.pending() : false;
    form.querySelectorAll('button[type="submit"]').forEach(function (button) { button.disabled = isBusy(form) || (needsTerms && !terms) || uploading; });
  }
  function say(el, text) { if (el) el.textContent = text || ""; }

  // ---------- Listings ----------
  function readQuery() {
    var params = new URLSearchParams(window.location.search);
    var query = {};
    FILTERS.concat(["code"]).forEach(function (key) { query[key] = params.get(key) || (key === "sort" ? "newest" : ""); });
    return query;
  }
  function queryUrl(query) {
    var url = new URL(window.location.href);
    FILTERS.concat(["code"]).forEach(function (key) {
      if (query[key] && !(key === "sort" && query[key] === "newest")) url.searchParams.set(key, query[key]);
      else url.searchParams.delete(key);
    });
    return url.pathname + url.search + url.hash;
  }
  function writeQuery(replace) {
    var next = queryUrl(state.query);
    if (next === window.location.pathname + window.location.search + window.location.hash) return;
    window.history[replace ? "replaceState" : "pushState"](window.history.state, "", next);
  }
  function filtered() { return FILTERS.some(function (key) { return key !== "sort" && state.query[key]; }); }

  // No count at all rather than "0 machines"; the empty board makes the pitch.
  function setCount(text) { say(count, text); if (count) count.hidden = !text; }
  function render() {
    grid.setAttribute("aria-busy", state.loading ? "true" : "false");
    var isFiltered = filtered();
    syncToolbar();
    root.querySelectorAll('[data-used-chip="model"]').forEach(function (chip) {
      var value = chip.getAttribute("data-value");
      chip.hidden = !!value && state.models.indexOf(value) === -1 && state.query.model !== value;
    });
    root.querySelectorAll("[data-used-reset]").forEach(function (el) { el.hidden = !isFiltered; });
    if (notice) notice.hidden = true;
    if (state.loading) {
      grid.hidden = false;
      grid.innerHTML = '<li class="used-board__skel" aria-hidden="true"></li>'.repeat(3);
      setCount(t("loading_listings"));
      if (empty) empty.hidden = true;
      return;
    }
    if (state.error || !state.listings.length) {
      grid.innerHTML = ""; grid.hidden = true;
      setCount("");
      if (empty) {
        empty.hidden = false;
        var title = empty.querySelector("[data-used-empty-title]"), copy = empty.querySelector("[data-used-empty-copy]"), retry = empty.querySelector("[data-used-retry]");
        say(title, state.error ? t("load_error_title") : isFiltered ? t("filtered_empty_title") : title.getAttribute("data-default"));
        say(copy, state.error ? t("load_error_body") : isFiltered ? t("filtered_empty_body") : copy.getAttribute("data-default"));
        if (retry) { retry.hidden = !state.error; retry.textContent = t("retry"); }
        empty.querySelectorAll("[data-used-empty-sell]").forEach(function (el) { el.hidden = state.error || isFiltered; });
        empty.classList.toggle("is-seller", !state.error && !isFiltered);
      }
      return;
    }
    if (empty) empty.hidden = true;
    grid.hidden = false;
    setCount(state.listings.length === 1 ? t("count_one", { n: 1 }) : t("count_many", { n: state.listings.length }));
    grid.innerHTML = state.listings.map(function (card, index) {
      var img = safeSrc(card.photo_urls && card.photo_urls[0]);
      var url = queryUrl(Object.assign({}, state.query, { code: card.code }));
      return '<li><a class="used-board__card" href="' + esc(url) + '" data-used-open="' + esc(card.code) + '">' +
        '<div class="used-board__card-media">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(card.model_title) + '" loading="' + (index < 3 ? "eager" : "lazy") + '">' : '<span class="used-board__small">' + esc(t("photo_unavailable")) + '</span>') + '</div>' +
        '<div class="used-board__card-body">' + (card.is_demo ? '<span class="used-board__badge">' + esc(t("sample")) + '</span>' : "") +
          '<h3>' + esc(card.model_title) + '</h3>' + (card.variant_title ? '<p class="used-board__card-variant">' + esc(card.variant_title) + '</p>' : "") +
          '<p class="used-board__card-price">' + esc(money(card.ask_price, card.currency)) + '</p>' +
          '<p class="used-board__card-meta">' + esc(card.city) + ' · ' + esc(conditionLabel(card.condition)) + '</p>' +
          '<p class="used-board__card-meta">' + esc(t("warranty_left", { v: warrantyText(card) })) + '</p>' +
        '</div></a></li>';
    }).join("");
  }

  // Filters are worth their space only once there is a real choice to make.
  // On phones they sit behind one Filters button.
  function syncToolbar() {
    var showFilters = !state.loading && !state.error && (state.total >= FILTER_THRESHOLD || filtered());
    if (filterToggle) filterToggle.hidden = !showFilters;
    if (toolbar) toolbar.hidden = !showFilters || !(filtersOpen || window.matchMedia("(min-width: 750px)").matches);
  }

  function load() {
    var request = ++listRequest;
    state.loading = true; state.error = false;
    render();
    var params = new URLSearchParams();
    FILTERS.forEach(function (key) { if (state.query[key]) params.set(key, state.query[key]); });
    json("/listings?" + params.toString()).then(function (body) {
      if (request !== listRequest) return;
      if (!Array.isArray(body.listings)) throw new Error("Invalid listings");
      state.listings = body.listings;
      state.total = typeof body.total === "number" ? body.total : body.listings.length;
      state.models = Array.isArray(body.models) ? body.models : body.listings.map(function (card) { return card.model_handle; });
      state.loading = false;
      render();
    }).catch(function () {
      if (request !== listRequest) return;
      state.listings = []; state.loading = false; state.error = true;
      render();
    });
  }

  function syncFilters() {
    root.querySelectorAll("[data-used-chip]").forEach(function (chip) {
      var on = (state.query[chip.getAttribute("data-used-chip")] || "") === (chip.getAttribute("data-value") || "");
      chip.classList.toggle("is-on", on);
      chip.setAttribute("aria-pressed", on ? "true" : "false");
    });
    [[cityInput, "city"], [sortSelect, "sort"], [conditionSelect, "condition"], [priceMin, "price_min"], [priceMax, "price_max"]].forEach(function (pair) {
      if (pair[0]) pair[0].value = state.query[pair[1]] || "";
    });
  }
  function applyFilters() {
    window.clearTimeout(filterTimer);
    if (cityInput) state.query.city = cityInput.value.trim();
    if (conditionSelect) state.query.condition = conditionSelect.value;
    if (sortSelect) state.query.sort = sortSelect.value;
    if (priceMin) state.query.price_min = priceMin.value;
    if (priceMax) state.query.price_max = priceMax.value;
    writeQuery(); syncFilters(); load();
  }

  // ---------- Listing detail, enquiry and report ----------
  function detailState(title, copy, retry) {
    detailBody.innerHTML = closeButton() + '<div class="used-board__state" role="status"><h2 id="used-detail-title" class="used-board__sheet-title">' + esc(title) + '</h2><p>' + esc(copy) + '</p>' +
      (retry ? '<button type="button" class="used-board__btn" data-used-detail-retry>' + esc(t("retry")) + '</button>' : "") + '</div>';
  }
  function openDetail(code, fromHistory) {
    if (!code || !detail) return;
    var request = ++detailRequest;
    state.query.code = code;
    if (!fromHistory) writeQuery();
    detailState(t("loading_machine"), t("loading_detail"), false);
    openSheet(detail);
    json("/listings/" + encodeURIComponent(code)).then(function (body) {
      if (request !== detailRequest || state.query.code !== code) return;
      if (!body.listing || body.listing.code !== code) throw new Error("Invalid listing");
      renderDetail(body.listing);
      track("listing_view", { code: code });
    }).catch(function (error) {
      if (request !== detailRequest || state.query.code !== code) return;
      var gone = error.status === 404 || error.status === 410;
      detailState(gone ? t("unavailable_title") : t("detail_error_title"), gone ? t("unavailable_body") : t("detail_error_body"), !gone);
    });
  }
  function closeDetail() {
    detailRequest += 1;
    state.query.code = "";
    writeQuery(true);
    closeSheet(detail);
  }
  function renderDetail(card) {
    var photos = (Array.isArray(card.photo_urls) ? card.photo_urls : []).map(safeSrc).filter(Boolean);
    var reason = reasonLabel(card.selling_reason), reasonHref = reasonUrl(card.selling_reason);
    var stage = '<div class="used-board__stage">' + (photos[0] ? '<img data-used-stage src="' + esc(photos[0]) + '" alt="' + esc(card.model_title) + '">' : '<p class="used-board__small">' + esc(t("photo_unavailable")) + '</p>') + '</div>';
    var thumbs = photos.length > 1 ? '<div class="used-board__thumbs" role="group">' + photos.map(function (src, i) {
      return '<button type="button" data-used-thumb="' + esc(src) + '" aria-label="' + esc(t("view_photo", { n: i + 1 })) + '" aria-pressed="' + (i === 0 ? "true" : "false") + '" class="' + (i === 0 ? "is-on" : "") + '"><img src="' + esc(src) + '" alt=""></button>';
    }).join("") + '</div>' : "";
    detailBody.innerHTML = closeButton() +
      '<div class="used-board__pdp"><div>' + stage + thumbs + '<p class="used-board__small">' + esc(t("photos_note")) + '</p></div>' +
      '<div class="used-board__buy"><p class="used-board__eyebrow">' + esc(card.is_demo ? t("sample") : t("private_listing")) + '</p>' +
        '<h2 id="used-detail-title" class="used-board__sheet-title">' + esc(card.model_title) + '</h2>' +
        (card.variant_title ? '<p class="used-board__card-variant">' + esc(card.variant_title) + '</p>' : "") +
        '<p class="used-board__price">' + esc(money(card.ask_price, card.currency)) + '</p>' +
        (card.is_demo ? "" : '<button type="button" class="used-board__btn used-board__btn--wide" data-used-contact>' + esc(t("contact_owner")) + '</button>') +
        '<dl class="used-board__specs"><div><dt>' + esc(t("spec_location")) + '</dt><dd>' + esc(card.city) + '</dd></div><div><dt>' + esc(t("spec_condition")) + '</dt><dd>' + esc(conditionLabel(card.condition)) + '</dd></div><div><dt>' + esc(t("spec_warranty")) + '</dt><dd>' + esc(warrantyText(card)) + '</dd></div><div><dt>' + esc(t("spec_handover")) + '</dt><dd>' + esc(t("handover_value")) + '</dd></div></dl>' +
        (card.notes ? '<div class="used-board__owner-notes"><p class="used-board__eyebrow">' + esc(t("from_owner")) + '</p><p>' + esc(card.notes) + '</p></div>' : "") +
        (Array.isArray(card.selected_accessories) && card.selected_accessories.length ? '<p class="used-board__detail-line"><strong>' + esc(t("included_accessories")) + ':</strong> ' + card.selected_accessories.map(function (item) { return esc(item.title) + (Number(item.quantity) > 1 ? " × " + Number(item.quantity) : ""); }).join(", ") + '</p>' : "") +
        (reason ? '<p class="used-board__detail-line">' + (reasonHref ? '<a href="' + esc(reasonHref) + '">' + esc(reason) + '</a>' : esc(reason)) + '</p>' : "") +
        '<p class="used-board__detail-line">' + esc(t("warranty_note")) + ' <a href="' + esc(cfg.warrantyUrl) + '">' + esc(t("read_warranty")) + '</a></p>' +
        (card.is_demo ? "" :
          '<form data-used-enquire class="used-board__form" novalidate>' +
            '<label class="used-board__field"><span>' + esc(t("your_email")) + '</span><input type="email" name="email" autocomplete="email" required maxlength="254"></label>' +
            '<label class="used-board__field"><span>' + esc(t("message")) + '</span><textarea name="message" required maxlength="2000" rows="4" placeholder="' + esc(t("message_placeholder")) + '"></textarea></label>' +
            '<p class="used-board__small">' + esc(t("enquiry_privacy")) + ' <a href="' + esc(cfg.privacyUrl) + '">' + esc(t("privacy")) + '</a></p>' +
            agreementsMarkup("buyer", "before_enquiry") +
            '<button type="submit" class="used-board__btn used-board__btn--wide" disabled>' + esc(t("send_enquiry")) + '</button><p class="used-board__form-msg" data-used-msg role="status" aria-live="polite"></p>' +
          '</form>' +
          '<details class="used-board__report"><summary>' + esc(t("report_link")) + '</summary>' +
            '<form data-used-report class="used-board__form" novalidate>' +
              '<label class="used-board__field"><span>' + esc(t("report_reason")) + '</span><select name="reason" required><option value="">' + esc(t("report_choose")) + '</option>' +
                ["sold", "inaccurate", "scam", "unsafe", "other"].map(function (key) { return '<option value="' + key + '">' + esc(t("report_" + key)) + '</option>'; }).join("") + '</select></label>' +
              '<label class="used-board__field"><span>' + esc(t("report_details")) + '</span><textarea name="details" maxlength="500" rows="3"></textarea></label>' +
              '<p class="used-board__small">' + esc(t("report_note")) + '</p>' +
              '<button type="submit" class="used-board__btn used-board__btn--ghost">' + esc(t("report_submit")) + '</button><p class="used-board__form-msg" data-used-msg role="status" aria-live="polite"></p>' +
            '</form></details>') +
      '</div></div>';
    var enquire = detailBody.querySelector("[data-used-enquire]");
    if (enquire) { renderAgreementGroup(enquire.querySelector("[data-used-agreements]")); enquire.addEventListener("submit", function (event) { event.preventDefault(); sendEnquiry(enquire, card); }); }
    var report = detailBody.querySelector("[data-used-report]");
    if (report) report.addEventListener("submit", function (event) { event.preventDefault(); sendReport(report, card); });
    var contact = detailBody.querySelector("[data-used-contact]");
    if (contact && enquire) contact.addEventListener("click", function () {
      enquire.scrollIntoView({ block: "start", behavior: "smooth" });
      enquire.querySelector('input[name="email"]').focus({ preventScroll: true });
      track("enquiry_open", { code: card.code });
    });
  }
  function sendEnquiry(form, card) {
    if (isBusy(form)) return;
    var msg = form.querySelector("[data-used-msg]");
    var email = form.querySelector('input[name="email"]'), text = form.querySelector('textarea[name="message"]');
    if (!email.value.trim() || !email.checkValidity()) { email.focus(); email.reportValidity(); return; }
    if (!text.value.trim()) { text.focus(); text.reportValidity(); return; }
    var agreements = readAgreements(form, "buyer");
    if (!agreements) { say(msg, t("agree_all")); return; }
    say(msg, "");
    setBusy(form, true, t("sending"));
    json("/listings/" + encodeURIComponent(card.code) + "/enquire", { method: "POST", body: { email: email.value.trim(), message: text.value.trim(), agreements: agreements } }).then(function (body) {
      if (body.relayed !== true) throw new Error("Delivery not confirmed");
      var done = document.createElement("p");
      done.className = "used-board__done"; done.setAttribute("role", "status"); done.textContent = t("enquiry_sent");
      form.replaceWith(done);
      track("enquiry_sent", { code: card.code });
    }).catch(function (error) {
      setBusy(form, false);
      if (error.status === 404) say(msg, t("unavailable_title"));
      else if (error.status === 429 && /today/i.test(error.message || "")) say(msg, t("enquiry_limit"));
      else if (error.code === "MARKETPLACE_AGREEMENTS_REQUIRED") { terms = null; loadTerms(); say(msg, t("agree_all")); }
      else say(msg, problem(error, "enquiry_error"));
    });
  }
  function sendReport(form, card) {
    if (isBusy(form)) return;
    var msg = form.querySelector("[data-used-msg]");
    var reason = form.querySelector('select[name="reason"]');
    if (!reason.value) { reason.focus(); say(msg, t("report_choose")); return; }
    setBusy(form, true, t("sending"));
    json("/listings/" + encodeURIComponent(card.code) + "/report", { method: "POST", body: { reason: reason.value, details: form.querySelector('textarea[name="details"]').value.trim() } }).then(function () {
      var done = document.createElement("p");
      done.className = "used-board__done"; done.setAttribute("role", "status"); done.textContent = t("report_done");
      form.replaceWith(done);
      track("report_sent", { reason: reason.value });
    }).catch(function (error) {
      setBusy(form, false);
      say(msg, error.status === 404 ? t("unavailable_title") : problem(error, "report_error"));
    });
  }

  // ---------- Order verification (shared by listing and managing) ----------
  // Renders the order-number and code steps into host and calls onVerified once
  // the code is confirmed. Returns a controller.
  function verifier(host, options) {
    var startedAt = Date.now(), resendAt = 0, resendTimer = 0, lateTimer = 0, run = 0;
    host.innerHTML =
      '<form class="used-board__form" data-used-verify novalidate>' +
        '<label class="used-board__field"><span>' + esc(t("order_number")) + '</span><input name="order_number" required autocomplete="off" maxlength="40" placeholder="' + esc(t("order_placeholder", { example: cfg.orderExample })) + '" aria-describedby="used-order-hint-' + options.id + '"></label>' +
        '<p class="used-board__small" id="used-order-hint-' + options.id + '">' + esc(t("order_hint")) + '</p>' +
        '<input type="text" name="website" class="used-board__hp" tabindex="-1" autocomplete="off" aria-hidden="true">' +
        '<button type="submit" class="used-board__btn used-board__btn--wide">' + esc(t("send_code")) + '</button>' +
        '<p class="used-board__form-msg" data-used-msg role="status"></p>' +
      '</form>' +
      '<form class="used-board__form" data-used-code hidden novalidate>' +
        '<label class="used-board__field"><span>' + esc(t("code_label")) + '</span><input name="otp" required inputmode="numeric" pattern="[0-9]{6}" maxlength="6" autocomplete="one-time-code" placeholder="' + esc(t("code_placeholder")) + '"></label>' +
        '<button type="submit" class="used-board__btn used-board__btn--wide">' + esc(t("confirm_code")) + '</button>' +
        '<p class="used-board__form-msg" data-used-msg role="status"></p>' +
        '<p class="used-board__small" data-used-late hidden>' + esc(t("code_late")) + '</p>' +
        '<div class="used-board__row"><button type="button" class="used-board__inline-btn" data-used-back>' + esc(t("change_order")) + '</button><button type="button" class="used-board__inline-btn" data-used-resend>' + esc(t("resend")) + '</button></div>' +
      '</form>';
    var orderForm = host.querySelector("[data-used-verify]"), codeForm = host.querySelector("[data-used-code]");
    var resend = host.querySelector("[data-used-resend]"), late = host.querySelector("[data-used-late]");
    function showStep(step) {
      orderForm.hidden = step !== 1; codeForm.hidden = step !== 2;
      if (options.onStep) options.onStep(step);
      requestAnimationFrame(function () { var input = (step === 1 ? orderForm : codeForm).querySelector("input:not([type=hidden]):not(.used-board__hp)"); if (input) input.focus({ preventScroll: true }); });
    }
    function updateResend() {
      window.clearTimeout(resendTimer);
      var seconds = Math.max(0, Math.ceil((resendAt - Date.now()) / 1000));
      resend.disabled = seconds > 0 || isBusy(codeForm) || isBusy(orderForm);
      resend.textContent = seconds ? t("resend_in", { n: seconds }) : t("resend");
      if (seconds) resendTimer = window.setTimeout(updateResend, 1000);
    }
    function sendCode(isResend) {
      if (isBusy(orderForm) || isBusy(codeForm)) return;
      var form = isResend ? codeForm : orderForm;
      var input = orderForm.querySelector('input[name="order_number"]');
      var number = isResend ? session.orderNumber : input.value.trim();
      if (!number) { input.focus(); input.reportValidity(); return; }
      var mine = ++run;
      setBusy(form, true, t("sending_code")); say(form.querySelector("[data-used-msg]"), ""); updateResend();
      new Promise(function (resolve) { window.setTimeout(resolve, Math.max(0, 1600 - (Date.now() - startedAt))); }).then(function () {
        return json("/verify-start", { method: "POST", body: { order_number: number, website: orderForm.querySelector('input[name="website"]').value, form_age_ms: Date.now() - startedAt } });
      }).then(function () {
        if (mine !== run) return;
        session.orderNumber = number; session.token = ""; session.expiresAt = 0;
        codeForm.querySelector('input[name="otp"]').value = "";
        resendAt = Date.now() + 60000;
        late.hidden = true; window.clearTimeout(lateTimer);
        lateTimer = window.setTimeout(function () { late.hidden = false; }, 120000);
        showStep(2);
        say(codeForm.querySelector("[data-used-msg]"), isResend ? t("code_resent") : "");
        track("otp_sent", { purpose: options.purpose });
      }).catch(function (error) {
        if (mine !== run) return;
        say(form.querySelector("[data-used-msg]"), problem(error, "code_request_error"));
      }).finally(function () { if (mine === run) { setBusy(form, false); updateResend(); } });
    }
    orderForm.addEventListener("submit", function (event) { event.preventDefault(); sendCode(false); });
    resend.addEventListener("click", function () { sendCode(true); });
    host.querySelector("[data-used-back]").addEventListener("click", function () { run += 1; window.clearTimeout(lateTimer); setBusy(codeForm, false); setBusy(orderForm, false); showStep(1); });
    codeForm.addEventListener("submit", function (event) {
      event.preventDefault();
      if (isBusy(codeForm)) return;
      var otp = codeForm.querySelector('input[name="otp"]');
      if (!/^\d{6}$/.test(otp.value.trim())) { otp.focus(); otp.reportValidity(); return; }
      var mine = ++run;
      setBusy(codeForm, true, t("checking_code")); say(codeForm.querySelector("[data-used-msg]"), ""); updateResend();
      json("/verify-confirm", { method: "POST", body: { order_number: session.orderNumber, otp: otp.value.trim() } }).then(function (body) {
        if (mine !== run) return;
        if (!body.token) throw new Error("Missing token");
        session.token = body.token;
        session.expiresAt = Date.now() + (Number(body.expires_in_ms) || 15 * 60 * 1000) - 30000;
        window.clearTimeout(lateTimer);
        track("otp_verified", { purpose: options.purpose });
        options.onVerified();
      }).catch(function (error) {
        if (mine !== run) return;
        say(codeForm.querySelector("[data-used-msg]"), error.status === 401 ? t("code_error") : error.status === 400 && error.code === "ORDER_NOT_ELIGIBLE" ? (cfg.lang === "en" ? error.message : t("no_machine")) : problem(error, "code_request_error"));
      }).finally(function () { if (mine === run) { setBusy(codeForm, false); updateResend(); } });
    });
    return {
      reset: function (message) {
        run += 1; window.clearTimeout(lateTimer); startedAt = Date.now();
        orderForm.reset(); codeForm.reset();
        setBusy(orderForm, false); setBusy(codeForm, false);
        if (session.orderNumber) orderForm.querySelector('input[name="order_number"]').value = session.orderNumber;
        say(orderForm.querySelector("[data-used-msg]"), message || ""); say(codeForm.querySelector("[data-used-msg]"), "");
        showStep(1); updateResend();
      },
      stop: function () { run += 1; window.clearTimeout(lateTimer); window.clearTimeout(resendTimer); },
    };
  }

  // ---------- Photos (shared by listing and managing) ----------
  // Uploads run one at a time. target() returns the multipart fields that tie a
  // photo to a machine (new listing) or a listing (manage view).
  function photoSet(listEl, messageEl, config) {
    var items = [], sequence = 0, resumeAt = 0, timer = 0;
    function label(category) { return t("cat_" + category); }
    function statusText(item) {
      if (item.status === "queued") return t("photo_queued");
      if (item.status === "uploading") return t("photo_uploading");
      if (item.status === "approved") return item.existing ? "" : t("photo_ok");
      if (item.status === "rejected") return t("photo_replace");
      return t("photo_failed");
    }
    function reasonText(item) {
      if (item.status === "rejected") return item.retry ? t("photo_checks_down") : (cfg.lang === "en" && item.reason ? item.reason : t("photo_replace_reason"));
      if (item.status === "error") return item.reason || "";
      return "";
    }
    function render() {
      listEl.innerHTML = items.map(function (item) {
        var src = item.preview || safeSrc(item.url);
        return '<li class="used-board__upload-item" data-status="' + esc(item.status) + '">' + (src ? '<img src="' + esc(src) + '" alt="">' : '<span class="used-board__thumb-empty"></span>') +
          '<div><strong>' + esc(label(item.category)) + '</strong>' + (statusText(item) ? '<p role="status">' + esc(statusText(item)) + '</p>' : "") + (reasonText(item) ? '<p>' + esc(reasonText(item)) + '</p>' : "") +
          '<div class="used-board__row">' + ((item.status === "error" || (item.status === "rejected" && item.retry)) && item.file ? '<button type="button" class="used-board__inline-btn" data-used-photo-retry="' + item.key + '">' + esc(t("retry_upload")) + '</button>' : "") +
          '<button type="button" class="used-board__inline-btn" data-used-photo-remove="' + item.key + '">' + esc(t("remove")) + '</button></div></div></li>';
      }).join("");
      if (config.onChange) config.onChange();
    }
    function next() {
      window.clearTimeout(timer);
      if (items.some(function (item) { return item.status === "uploading"; })) return;
      if (resumeAt > Date.now()) { timer = window.setTimeout(next, resumeAt - Date.now()); return; }
      var item = items.find(function (candidate) { return candidate.status === "queued"; });
      if (item) upload(item);
    }
    function upload(item) {
      var auth = config.auth();
      if (!auth) { item.status = "error"; item.reason = t("photo_session"); render(); if (config.onExpired) config.onExpired(); return; }
      item.status = "uploading"; item.reason = "";
      item.controller = typeof AbortController !== "undefined" ? new AbortController() : null;
      var abortTimer = window.setTimeout(function () { if (item.controller) item.controller.abort(); }, 120000);
      var data = new FormData();
      data.append("file", item.file);
      var fields = config.target();
      Object.keys(fields).forEach(function (key) { data.append(key, fields[key]); });
      data.append("category", item.category);
      render();
      fetch(cfg.api + "/photos", { method: "POST", credentials: "omit", headers: { Authorization: auth }, body: data, signal: item.controller ? item.controller.signal : undefined }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (body) {
          if (!res.ok || body.ok !== true || !body.photo) { var error = new Error(body.error || "Upload failed"); error.status = res.status; error.code = body.code; throw error; }
          return body.photo;
        });
      }).then(function (photo) {
        if (items.indexOf(item) === -1) return;
        item.id = photo.id; item.status = photo.status === "approved" ? "approved" : "rejected"; item.reason = photo.review_reason || ""; item.retry = !!photo.retry; item.url = photo.url;
      }).catch(function (error) {
        if (items.indexOf(item) === -1) return;
        if (error.status === 429 && error.code === "PHOTO_BUSY") { item.status = "queued"; resumeAt = Date.now() + 2000; return; }
        item.status = "error";
        item.reason = error.status === 401 ? t("photo_session") : error.name === "AbortError" ? t("photo_slow") : error.status === 429 ? t("too_many") : (cfg.lang === "en" && error.message !== "Upload failed" ? error.message : t("photo_failed"));
        if (error.status === 401 && config.onExpired) config.onExpired();
      }).finally(function () { window.clearTimeout(abortTimer); item.controller = null; render(); next(); });
    }
    function add(files, category) {
      var errors = [];
      Array.prototype.slice.call(files || []).forEach(function (file) {
        if (items.length >= 8) { errors.push(t("photo_limit")); return; }
        if (!/^image\/(jpeg|png|webp)$/.test(file.type)) { errors.push(/\.hei[cf]$/i.test(file.name) || /hei[cf]/i.test(file.type) ? t("photo_heic") : t("photo_type")); return; }
        if (file.size > 10 * 1024 * 1024 || file.size <= 0) { errors.push(t("photo_size")); return; }
        items.push({ key: ++sequence, file: file, category: category, preview: URL.createObjectURL(file), status: "queued", reason: "" });
      });
      say(messageEl, errors.filter(function (value, i, all) { return all.indexOf(value) === i; }).join(" "));
      render(); next();
    }
    listEl.addEventListener("click", function (event) {
      var remove = event.target.closest("[data-used-photo-remove]"), retry = event.target.closest("[data-used-photo-retry]");
      if (remove) {
        var key = Number(remove.getAttribute("data-used-photo-remove"));
        items = items.filter(function (item) { if (item.key === key) { if (item.controller) item.controller.abort(); if (item.preview) URL.revokeObjectURL(item.preview); return false; } return true; });
        render(); next();
      } else if (retry) {
        var again = items.find(function (item) { return item.key === Number(retry.getAttribute("data-used-photo-retry")); });
        if (again) { again.status = "queued"; again.reason = ""; again.retry = false; render(); next(); }
      }
    });
    return {
      add: add,
      seed: function (photos) { items = photos.map(function (photo) { return { key: ++sequence, id: photo.id, url: photo.url, category: photo.category, status: "approved", existing: true }; }); render(); },
      clear: function () { items.forEach(function (item) { if (item.controller) item.controller.abort(); if (item.preview) URL.revokeObjectURL(item.preview); }); items = []; render(); },
      pending: function () { return items.some(function (item) { return item.status === "uploading" || item.status === "queued"; }); },
      ids: function () { return items.filter(function (item) { return item.id && item.status === "approved"; }).sort(function (a, b) { return CATEGORIES.indexOf(a.category) - CATEGORIES.indexOf(b.category); }).map(function (item) { return item.id; }); },
      problem: function (required) {
        if (items.some(function (item) { return item.status === "uploading" || item.status === "queued"; })) return t("photo_wait");
        if (items.some(function (item) { return item.status === "error" || item.status === "rejected"; })) return t("photo_fix");
        var present = items.filter(function (item) { return item.id && item.status === "approved"; }).map(function (item) { return item.category; });
        var missing = required.filter(function (category) { return present.indexOf(category) === -1; });
        return missing.length ? t("photo_missing", { list: missing.map(label).join(", ") }) : "";
      },
    };
  }
  function uploadInputs(requiredMap) {
    return '<div class="used-board__photo-inputs">' + CATEGORIES.map(function (category) {
      return '<label class="used-board__upload"><strong>' + esc(t("cat_" + category)) + ' <span data-used-need="' + category + '">' + esc(requiredMap[category]) + '</span></strong><p>' + esc(t("cat_" + category + "_hint")) + '</p><input type="file" accept="image/jpeg,image/png,image/webp" data-used-photo-category="' + category + '" multiple></label>';
    }).join("") + '</div>';
  }

  // ---------- Selling ----------
  var sell = null;
  function sellMarkup() {
    return closeButton() + '<div class="used-board__narrow">' +
      '<p class="used-board__eyebrow" data-used-sell-kicker></p><h2 class="used-board__sheet-title" id="used-sell-title" data-used-sell-title></h2><p class="used-board__sheet-copy" data-used-sell-copy></p>' +
      '<div data-used-sell-verify></div>' +
      '<form class="used-board__form" data-used-selection hidden novalidate>' +
        '<p class="used-board__machine" data-used-order-label></p>' +
        '<fieldset class="used-board__selection"><legend>' + esc(t("which_machine")) + '</legend><p class="used-board__small">' + esc(t("which_machine_hint")) + '</p><div data-used-machines></div></fieldset>' +
        '<fieldset class="used-board__selection" data-used-accessory-section hidden><legend>' + esc(t("accessories_title")) + '</legend><p class="used-board__small">' + esc(t("accessories_hint")) + '</p><div data-used-accessories></div></fieldset>' +
        '<button type="submit" class="used-board__btn used-board__btn--wide" data-used-selection-next disabled>' + esc(t("continue")) + '</button>' +
        '<p class="used-board__form-msg" data-used-msg role="status"></p>' +
        '<div class="used-board__row"><button type="button" class="used-board__inline-btn" data-used-order-retry>' + esc(t("reload_order")) + '</button><button type="button" class="used-board__inline-btn" data-used-change-order>' + esc(t("other_order")) + '</button></div>' +
      '</form>' +
      '<form class="used-board__form" data-used-list hidden novalidate>' +
        '<p class="used-board__machine" data-used-machine></p>' +
        '<button type="button" class="used-board__inline-btn used-board__back" data-used-selection-back>' + esc(t("change_machine")) + '</button>' +
        '<h3 class="used-board__form-heading">' + esc(t("details_title")) + '</h3>' +
        '<label class="used-board__field"><span>' + esc(t("why_selling")) + '</span><select name="selling_reason" required><option value="">' + esc(t("choose_upgrade")) + '</option><option value="upgrade_gm3">' + esc(t("reason_gm3")) + '</option><option value="upgrade_ultra">' + esc(t("reason_ultra")) + '</option></select></label>' +
        '<p class="used-board__small"><a href="' + esc(cfg.gm3Url) + '" target="_blank" rel="noopener">' + esc(t("see_gm3")) + '</a> · <a href="' + esc(cfg.ultraUrl) + '" target="_blank" rel="noopener">' + esc(t("see_ultra")) + '</a></p>' +
        '<label class="used-board__field"><span>' + esc(t("city")) + '</span><input name="city" required maxlength="80" autocomplete="address-level2"></label>' +
        '<label class="used-board__field"><span>' + esc(t("condition")) + '</span><select name="condition" required><option value="excellent">' + esc(t("cond_excellent")) + '</option><option value="good">' + esc(t("cond_good")) + '</option><option value="fair">' + esc(t("cond_fair")) + '</option></select></label>' +
        '<p class="used-board__small">' + esc(t("safe_only")) + (cfg.careUrl ? ' <a href="' + esc(cfg.careUrl) + '" target="_blank" rel="noopener">Speediance Care</a>' : "") + '</p>' +
        '<label class="used-board__field"><span>' + esc(t("asking_price")) + ' (' + esc(cfg.currency) + ')</span><input name="ask_price" type="number" min="0" step="1" inputmode="numeric" required></label>' +
        '<label class="used-board__field"><span>' + esc(t("description")) + '</span><textarea name="notes" maxlength="2000" rows="4" placeholder="' + esc(t("description_placeholder")) + '"></textarea></label>' +
        '<p class="used-board__small">' + esc(t("public_note")) + '</p>' +
        '<h3 class="used-board__form-heading">' + esc(t("photos_title")) + '</h3><p class="used-board__small">' + esc(t("photos_hint")) + '</p>' +
        uploadInputs({ whole_unit: t("required"), screen: t("required"), accessories: t("when_included"), wear: t("recommended") }) +
        '<p class="used-board__form-msg" data-used-photo-msg role="status"></p><ul class="used-board__uploads" data-used-photo-list></ul>' +
        '<h3 class="used-board__form-heading">' + esc(t("confirm_title")) + '</h3><p class="used-board__small">' + esc(t("enquiries_note")) + ' <a href="' + esc(cfg.privacyUrl) + '">' + esc(t("privacy")) + '</a></p>' +
        agreementsMarkup("seller", "before_publish") +
        '<button type="submit" class="used-board__btn used-board__btn--wide" disabled>' + esc(t("publish")) + '</button>' +
        '<p class="used-board__form-msg" data-used-msg role="status"></p>' +
      '</form>' +
      '<div class="used-board__done-panel" data-used-list-done role="status" hidden></div>' +
    '</div>';
  }
  function buildSell() {
    if (sell) return sell;
    sellBody.innerHTML = sellMarkup();
    var s = { machine: null, machines: [], accessories: [], selected: [], orderRequest: 0 };
    s.kicker = sellBody.querySelector("[data-used-sell-kicker]"); s.title = sellBody.querySelector("[data-used-sell-title]"); s.copy = sellBody.querySelector("[data-used-sell-copy]");
    s.selection = sellBody.querySelector("[data-used-selection]"); s.list = sellBody.querySelector("[data-used-list]"); s.done = sellBody.querySelector("[data-used-list-done]");
    s.verify = verifier(sellBody.querySelector("[data-used-sell-verify]"), { id: "sell", purpose: "sell", onStep: function (step) { setSellStep(step); }, onVerified: function () { loadOrder(); } });
    s.photos = photoSet(s.list.querySelector("[data-used-photo-list]"), s.list.querySelector("[data-used-photo-msg]"), {
      auth: function () { return sessionLive() ? bearer() : ""; },
      target: function () { return { machine_id: s.machine ? s.machine.id : "" }; },
      onExpired: function () { expireSell(t("photo_session")); },
      onChange: function () { syncSubmit(s.list); updateNeeds(); },
    });
    s.list._photos = s.photos;
    s.list.querySelectorAll("[data-used-photo-category]").forEach(function (input) {
      input.addEventListener("change", function () { if (s.machine && sessionLive()) s.photos.add(input.files, input.getAttribute("data-used-photo-category")); else expireSell(); input.value = ""; });
    });
    s.list.querySelector('select[name="condition"]').addEventListener("change", updateNeeds);
    s.selection.addEventListener("change", updateSelection);
    s.selection.addEventListener("submit", function (event) { event.preventDefault(); chooseMachine(); });
    s.list.addEventListener("submit", function (event) { event.preventDefault(); publish(); });
    sellBody.addEventListener("click", function (event) {
      if (event.target.closest("[data-used-order-retry]")) loadOrder();
      else if (event.target.closest("[data-used-change-order]")) { session.token = ""; session.expiresAt = 0; s.machine = null; s.photos.clear(); s.verify.reset(); }
      else if (event.target.closest("[data-used-selection-back]") && !isBusy(s.list)) { setSellStep(3); updateSelection(); }
      else if (event.target.closest("[data-used-list-another]")) { s.machine = null; s.photos.clear(); s.list.reset(); loadOrder(); }
      else if (event.target.closest("[data-used-manage-now]")) { closeSheet(sellDialog); openManage(); }
    });
    renderAgreementGroup(s.list.querySelector("[data-used-agreements]"));
    sell = s;
    return s;
  }
  function setSellStep(step) {
    var s = sell;
    s.selection.hidden = step !== 3; s.list.hidden = step !== 4; s.done.hidden = true;
    sellBody.querySelector("[data-used-sell-verify]").hidden = step > 2;
    say(s.kicker, t("step", { n: step })); say(s.title, t("sell_title_" + step)); say(s.copy, t("sell_copy_" + step, { name: cfg.regionName })); s.copy.hidden = false;
    if (step >= 3) requestAnimationFrame(function () { var input = (step === 3 ? s.selection : s.list).querySelector("input:not([disabled]),select"); if (input) input.focus({ preventScroll: true }); });
  }
  function expireSell(message) {
    session.token = ""; session.expiresAt = 0;
    sell.verify.reset(message || t("session_expired"));
  }
  function openSell() {
    var s = buildSell();
    if (!terms && !termsRequest) loadTerms();
    s.done.hidden = true;
    if (sessionLive()) loadOrder(); else s.verify.reset();
    openSheet(sellDialog);
    track("sell_open");
  }
  function loadOrder() {
    var s = sell;
    if (!sessionLive()) { expireSell(); return; }
    var request = ++s.orderRequest;
    setSellStep(3);
    setBusy(s.selection, true);
    say(s.selection.querySelector("[data-used-msg]"), t("loading_order"));
    json("/status", { auth: bearer() }).then(function (status) {
      if (request !== s.orderRequest) return;
      if (!Array.isArray(status.machines) || !Array.isArray(status.accessories)) throw new Error("Invalid order");
      renderOrder(status);
    }).catch(function (error) {
      if (request !== s.orderRequest) return;
      if (error.status === 401) { expireSell(); return; }
      say(s.selection.querySelector("[data-used-msg]"), error.code === "ORDER_NOT_ELIGIBLE" ? (cfg.lang === "en" ? error.message : t("no_machine")) : t("order_error"));
    }).finally(function () { if (request === s.orderRequest) { setBusy(s.selection, false); updateSelection(); } });
  }
  function renderOrder(status) {
    var s = sell;
    s.machines = status.machines; s.accessories = status.accessories;
    say(s.selection.querySelector("[data-used-order-label]"), status.order_label || "");
    s.selection.querySelector("[data-used-machines]").innerHTML = s.machines.map(function (item) {
      var enabled = item.eligible === true;
      var reason = !enabled ? (item.existing_listing ? t("machine_listed") : t("machine_unavailable")) : "";
      return '<label class="used-board__choice' + (enabled ? "" : " is-unavailable") + '"><input type="radio" name="machine_id" value="' + esc(item.id) + '"' + (enabled ? "" : " disabled") + (s.machine && s.machine.id === item.id && enabled ? " checked" : "") + '><span><strong>' + esc(item.model_title) + '</strong>' +
        (item.variant_title ? '<span>' + esc(item.variant_title) + '</span>' : "") + (Number(item.quantity) > 1 ? '<span>' + esc(t("unit_of", { n: Number(item.unit_number), total: Number(item.quantity) })) + '</span>' : "") +
        '<span>' + esc(t("warranty_left", { v: warrantyText(item) })) + '</span>' + (reason ? '<span>' + esc(reason) + '</span>' : "") + '</span></label>';
    }).join("");
    var available = s.machines.some(function (item) { return item.eligible === true; });
    s.selection.querySelector("[data-used-accessory-section]").hidden = !s.accessories.length || !available;
    s.selection.querySelector("[data-used-accessories]").innerHTML = s.accessories.map(function (item) {
      return '<label class="used-board__choice"><input type="checkbox" name="accessory_id" value="' + esc(item.id) + '"' + (s.selected.indexOf(item.id) !== -1 ? " checked" : "") + '><span><strong>' + esc(item.title) + '</strong>' + (Number(item.quantity) > 1 ? '<span>' + esc(t("quantity", { n: Number(item.quantity) })) + '</span>' : "") + '</span></label>';
    }).join("");
    say(s.selection.querySelector("[data-used-msg]"), !s.machines.length || status.unavailable_code === "NO_MAIN_MACHINE" ? t("no_machine") : "");
  }
  function updateSelection() {
    var s = sell;
    var choice = s.selection.querySelector('input[name="machine_id"]:checked');
    var enabled = !!choice && s.machines.some(function (item) { return item.id === choice.value && item.eligible === true; });
    s.selection.querySelector("[data-used-selection-next]").disabled = !enabled || isBusy(s.selection);
    s.selection.querySelectorAll('input[name="accessory_id"]').forEach(function (input) { input.disabled = !enabled; });
  }
  function chooseMachine() {
    var s = sell;
    if (!sessionLive()) { expireSell(); return; }
    var choice = s.selection.querySelector('input[name="machine_id"]:checked');
    var picked = choice && s.machines.find(function (item) { return item.id === choice.value && item.eligible === true; });
    if (!picked) { say(s.selection.querySelector("[data-used-msg]"), t("choose_machine")); return; }
    if (!s.machine || s.machine.id !== picked.id) s.photos.clear();
    s.machine = picked;
    s.selected = Array.prototype.map.call(s.selection.querySelectorAll('input[name="accessory_id"]:checked'), function (input) { return input.value; });
    say(s.list.querySelector("[data-used-machine]"), picked.model_title + (picked.variant_title ? " · " + picked.variant_title : "") + " · " + t("warranty_left", { v: warrantyText(picked) }));
    updateNeeds();
    setSellStep(4);
  }
  function requiredCategories() {
    var s = sell, required = ["whole_unit", "screen"];
    if (s.selected.length) required.push("accessories");
    if (s.list.querySelector('select[name="condition"]').value === "fair") required.push("wear");
    return required;
  }
  function updateNeeds() {
    if (!sell) return;
    var required = requiredCategories();
    sell.list.querySelectorAll("[data-used-need]").forEach(function (el) {
      var category = el.getAttribute("data-used-need");
      el.textContent = required.indexOf(category) !== -1 ? t("required") : category === "accessories" ? t("when_included") : t("recommended");
    });
  }
  function publish() {
    var s = sell, form = s.list, msg = form.querySelector("[data-used-msg]");
    if (isBusy(form)) return;
    if (!sessionLive() || !s.machine) { expireSell(); return; }
    var photoProblem = s.photos.problem(requiredCategories());
    if (photoProblem) { say(msg, photoProblem); say(form.querySelector("[data-used-photo-msg]"), photoProblem); return; }
    var reason = form.querySelector('select[name="selling_reason"]');
    if (!reason.value) { say(msg, t("choose_reason")); reason.focus(); return; }
    var city = form.querySelector('input[name="city"]'), price = form.querySelector('input[name="ask_price"]');
    if (!city.value.trim()) { city.focus(); city.reportValidity(); return; }
    if (price.value === "" || !(Number(price.value) >= 0)) { say(msg, t("price_invalid")); price.focus(); return; }
    var agreements = readAgreements(form, "seller");
    if (!agreements) { say(msg, t("agree_all")); return; }
    say(msg, "");
    setBusy(form, true, t("publishing"));
    json("/listings", { method: "POST", auth: bearer(), timeoutMs: 120000, body: {
      machine_id: s.machine.id, accessory_ids: s.selected.slice(), photo_ids: s.photos.ids(), selling_reason: reason.value,
      city: city.value.trim(), condition: form.querySelector('select[name="condition"]').value, ask_price: Number(price.value),
      notes: form.querySelector('textarea[name="notes"]').value.trim(), agreements: agreements, locale: cfg.lang,
    } }).then(function (body) {
      if (!body.listing || !body.listing.code || body.listing.status !== "live") throw new Error("Not live");
      // A link token opens only the listing it was issued for. From here the
      // verified order session is the one that also sees the new listing.
      manageToken = "";
      form.hidden = true;
      say(s.kicker, t("published_kicker")); say(s.title, t("published_title")); s.copy.hidden = true;
      s.done.hidden = false;
      s.done.innerHTML = '<p>' + esc(t("published_body")) + '</p><p>' + esc(body.manage_link_sent ? t("manage_email_sent") : t("manage_email_failed")) + '</p>' +
        '<p class="used-board__small">' + esc(t("reference", { code: body.listing.code })) + '</p>' +
        '<div class="used-board__row"><a class="used-board__btn" href="' + esc(pageUrl({ code: body.listing.code })) + '">' + esc(t("view_listing")) + '</a><button type="button" class="used-board__btn used-board__btn--ghost" data-used-manage-now>' + esc(t("manage_now")) + '</button></div>' +
        '<button type="button" class="used-board__inline-btn" data-used-list-another>' + esc(t("list_another")) + '</button>' +
        '<div class="used-board__upgrade-mini"><p><strong>' + esc(t("upgrade_line")) + '</strong></p><p><a href="' + esc(cfg.gm3Url) + '">' + esc(t("see_gm3")) + '</a> · <a href="' + esc(cfg.ultraUrl) + '">' + esc(t("see_ultra")) + '</a></p></div>';
      s.photos.clear(); form.reset();
      track("listing_submitted", { code: body.listing.code });
      load();
    }).catch(function (error) {
      if (error.status === 401) { expireSell(); return; }
      if (error.code === "MARKETPLACE_AGREEMENTS_REQUIRED") { terms = null; loadTerms(); say(msg, t("agree_all")); return; }
      say(msg, error.status >= 500 || !error.status ? t("publish_error") : problem(error, "publish_error"));
    }).finally(function () { setBusy(form, false); });
  }

  // ---------- Managing ----------
  var manage = null;
  function buildManage() {
    if (manage) return manage;
    manageBody.innerHTML = closeButton() + '<div class="used-board__narrow"><p class="used-board__eyebrow">' + esc(cfg.regionName) + '</p><h2 class="used-board__sheet-title" id="used-manage-title">' + esc(t("manage_title")) + '</h2>' +
      '<p class="used-board__sheet-copy" data-used-manage-copy></p><div data-used-manage-verify></div><p class="used-board__form-msg" data-used-manage-msg role="status"></p><div data-used-manage-list></div></div>';
    var m = { copy: manageBody.querySelector("[data-used-manage-copy]"), verifyHost: manageBody.querySelector("[data-used-manage-verify]"), msg: manageBody.querySelector("[data-used-manage-msg]"), list: manageBody.querySelector("[data-used-manage-list]"), auth: "", request: 0, resume: null };
    m.verify = verifier(m.verifyHost, { id: "manage", purpose: "manage", onVerified: function () {
      m.auth = bearer();
      if (!m.resume) { loadManage(); return; }
      // Verified to finish a save: keep every edit on screen and let the seller save again.
      var form = m.resume;
      m.resume = null;
      m.verifyHost.hidden = true; say(m.copy, "");
      say(form.querySelector("[data-used-msg]"), t("verified_save"));
      var button = form.querySelector('button[type="submit"]');
      if (button) { button.scrollIntoView({ block: "center", behavior: "smooth" }); button.focus({ preventScroll: true }); }
    } });
    manageBody.addEventListener("click", function (event) {
      if (event.target.closest("[data-used-manage-retry]")) { loadManage(); return; }
      if (event.target.closest("[data-used-manage-order]")) { m.list.innerHTML = ""; say(m.msg, ""); orderRoute(); }
    });
    manage = m;
    return m;
  }
  function orderRoute(copy) {
    var m = manage;
    m.request += 1; m.auth = "";
    m.verifyHost.hidden = false; say(m.copy, copy || t("manage_intro"));
    m.verify.reset();
  }
  function openManage() {
    var m = buildManage();
    m.list.innerHTML = ""; say(m.msg, ""); m.resume = null;
    if (manageToken) { m.auth = "Listing " + manageToken; loadManage(); }
    else if (sessionLive()) { m.auth = bearer(); loadManage(); }
    else { m.auth = ""; m.verifyHost.hidden = false; say(m.copy, t("manage_intro")); m.verify.reset(); }
    openSheet(manageDialog);
    track("manage_open", { via: manageToken ? "link" : "order" });
  }
  function loadManage() {
    var m = manage, request = ++m.request;
    m.verifyHost.hidden = true; say(m.copy, ""); say(m.msg, t("manage_loading")); m.list.innerHTML = "";
    json("/manage", { auth: m.auth }).then(function (body) {
      if (request !== m.request) return;
      say(m.msg, body.listings.length ? "" : t("manage_none"));
      m.list.innerHTML = "";
      body.listings.forEach(function (listing) { m.list.appendChild(manageCard(listing)); });
    }).catch(function (error) {
      if (request !== m.request) return;
      if (error.status === 401) {
        if (m.auth.indexOf("Listing ") === 0) manageToken = "";
        session.token = ""; session.expiresAt = 0; m.auth = "";
        m.verifyHost.hidden = false; say(m.copy, t("manage_intro"));
        m.verify.reset(error.code === "MANAGE_LINK_INVALID" ? t("manage_link_invalid") : t("session_expired"));
        say(m.msg, "");
        return;
      }
      // Not found, server error or no connection: retry with the same credential,
      // or switch a private-link visit to the order-number route.
      say(m.msg, t("manage_error"));
      m.list.innerHTML = '<div class="used-board__row used-board__manage-retry"><button type="button" class="used-board__btn" data-used-manage-retry>' + esc(t("retry")) + '</button>' +
        (m.auth.indexOf("Listing ") === 0 ? '<button type="button" class="used-board__inline-btn" data-used-manage-order>' + esc(t("manage_use_order")) + '</button>' : "") + '</div>';
    });
  }
  function manageCard(listing) {
    var card = document.createElement("article");
    card.className = "used-board__manage-card";
    function paint(current) {
      var editable = current.can_edit === true, closable = current.can_close === true;
      card.innerHTML = '<header><h3>' + esc(current.model_title) + '</h3><span class="used-board__status" data-status="' + esc(current.status) + '">' + esc(t("status_" + current.status)) + '</span></header>' +
        '<p class="used-board__small">' + esc(t("reference", { code: current.code })) + (current.status === "live" ? ' · <a href="' + esc(pageUrl({ code: current.code })) + '">' + esc(t("view_listing")) + '</a>' : "") + '</p>' +
        (current.status === "reported" ? '<p class="used-board__detail-line">' + esc(t("reported_note")) + ' <button type="button" class="used-board__inline-btn" data-used-relist>' + esc(t("list_again")) + '</button></p>' : "") +
        (current.status === "expired" && closable ? '<p class="used-board__detail-line">' + esc(t("expired_note")) + '</p><div class="used-board__row used-board__relist"><button type="button" class="used-board__btn" data-used-close-ask="relist">' + esc(t("remove_relist")) + '</button></div>' : "") +
        (editable ?
          '<form class="used-board__form" data-used-edit novalidate>' +
            '<label class="used-board__field"><span>' + esc(t("asking_price")) + ' (' + esc(current.currency) + ')</span><input name="ask_price" type="number" min="0" step="1" inputmode="numeric" required value="' + esc(Math.round(Number(current.ask_price))) + '"></label>' +
            '<label class="used-board__field"><span>' + esc(t("description")) + '</span><textarea name="notes" maxlength="2000" rows="4">' + esc(current.notes || "") + '</textarea></label>' +
            '<h4 class="used-board__form-heading">' + esc(t("photos")) + '</h4><ul class="used-board__uploads" data-used-photo-list></ul><p class="used-board__form-msg" data-used-photo-msg role="status"></p>' +
            '<div class="used-board__add-photo"><label class="used-board__field"><span>' + esc(t("photo_kind")) + '</span><select data-used-add-category>' + CATEGORIES.map(function (category) { return '<option value="' + category + '">' + esc(t("cat_" + category)) + '</option>'; }).join("") + '</select></label>' +
              '<label class="used-board__btn used-board__btn--ghost used-board__file-btn">' + esc(t("add_photo")) + '<input type="file" accept="image/jpeg,image/png,image/webp" data-used-add-photo></label></div>' +
            '<button type="submit" class="used-board__btn used-board__btn--wide">' + esc(t("save")) + '</button><p class="used-board__form-msg" data-used-msg role="status" aria-live="polite"></p>' +
          '</form>' : "") +
        (closable ? '<div class="used-board__row used-board__close-actions" data-used-close-actions>' + (current.status !== "reported" ? '<button type="button" class="used-board__btn used-board__btn--ghost" data-used-close-ask="sold">' + esc(t("mark_sold")) + '</button>' : "") + '<button type="button" class="used-board__inline-btn used-board__danger" data-used-close-ask="remove">' + esc(t("remove_listing")) + '</button></div><div class="used-board__confirm" data-used-confirm hidden></div>' : "") +
        '<p class="used-board__form-msg" data-used-card-msg role="status" aria-live="polite"></p>';
      var edit = card.querySelector("[data-used-edit]");
      if (edit) {
        var photos = photoSet(edit.querySelector("[data-used-photo-list]"), edit.querySelector("[data-used-photo-msg]"), {
          auth: function () { return manage.auth; },
          target: function () { return { listing_code: current.code }; },
          onChange: function () { syncSubmit(edit); },
        });
        edit._photos = photos;
        photos.seed(current.photos || []);
        edit.querySelector("[data-used-add-photo]").addEventListener("change", function (event) {
          photos.add(event.target.files, edit.querySelector("[data-used-add-category]").value);
          event.target.value = "";
        });
        edit.addEventListener("submit", function (event) { event.preventDefault(); save(edit, current, photos); });
      }
    }
    function save(form, current, photos) {
      if (isBusy(form)) return;
      var msg = form.querySelector("[data-used-msg]");
      var price = form.querySelector('input[name="ask_price"]');
      if (price.value === "" || !(Number(price.value) >= 0)) { say(msg, t("price_invalid")); price.focus(); return; }
      var required = ["whole_unit", "screen"];
      if (current.condition === "fair") required.push("wear");
      if (Array.isArray(current.selected_accessories) && current.selected_accessories.length) required.push("accessories");
      var photoProblem = photos.problem(required);
      if (photoProblem) { say(msg, photoProblem); return; }
      var ids = photos.ids();
      if (ids.length < 2) { say(msg, t("keep_two")); return; }
      // Still waiting for the order code: point back at it without restarting it.
      if (!manage.auth) { manage.resume = form; say(msg, t("verify_to_save")); manage.verifyHost.scrollIntoView({ block: "center", behavior: "smooth" }); return; }
      setBusy(form, true, t("saving")); say(msg, "");
      json("/manage/" + encodeURIComponent(current.code), { method: "POST", auth: manage.auth, timeoutMs: 120000, body: { action: "update", ask_price: Number(price.value), notes: form.querySelector('textarea[name="notes"]').value.trim(), photo_ids: ids } }).then(function (body) {
        paint(body.listing);
        say(card.querySelector("[data-used-card-msg]"), body.unchanged ? t("no_changes") : t("saved"));
        if (!body.unchanged) { track("listing_updated", { code: current.code }); load(); }
      }).catch(function (error) {
        setBusy(form, false);
        if (error.status === 401) { verifyToSave(form); return; }
        say(msg, error.code === "INVALID_PRICE" ? t("price_invalid") : problem(error, "manage_edit_error"));
      });
    }
    // The credential lapsed mid-edit. Keep the form exactly as it is, drop only
    // the credential that failed, and ask for the order code before saving again.
    function verifyToSave(form) {
      if (manage.auth.indexOf("Listing ") === 0) manageToken = "";
      else { session.token = ""; session.expiresAt = 0; }
      manage.resume = form;
      say(form.querySelector("[data-used-msg]"), t("verify_to_save"));
      orderRoute(t("verify_to_save"));
      manage.verifyHost.scrollIntoView({ block: "center", behavior: "smooth" });
    }
    card.addEventListener("click", function (event) {
      var ask = event.target.closest("[data-used-close-ask]");
      var confirmBox = card.querySelector("[data-used-confirm]");
      if (ask && confirmBox) {
        // "relist" is the remove action followed by the sell flow.
        var action = ask.getAttribute("data-used-close-ask"), sold = action === "sold";
        confirmBox.hidden = false;
        confirmBox.innerHTML = '<p>' + esc(sold ? t("confirm_sold") : t("confirm_remove")) + '</p><div class="used-board__row"><button type="button" class="used-board__btn" data-used-close-do="' + (sold ? "sold" : "remove") + '"' + (action === "relist" ? " data-used-then-sell" : "") + '>' + esc(sold ? t("yes_sold") : t("yes_remove")) + '</button><button type="button" class="used-board__inline-btn" data-used-close-cancel>' + esc(t("keep")) + '</button></div>';
        confirmBox.querySelector("[data-used-close-do]").focus();
        return;
      }
      if (event.target.closest("[data-used-close-cancel]") && confirmBox) { confirmBox.hidden = true; confirmBox.innerHTML = ""; return; }
      var go = event.target.closest("[data-used-close-do]");
      if (go) {
        var what = go.getAttribute("data-used-close-do"), thenSell = go.hasAttribute("data-used-then-sell");
        go.disabled = true;
        json("/manage/" + encodeURIComponent(listing.code), { method: "POST", auth: manage.auth, body: { action: what } }).then(function (body) {
          listing = body.listing;
          paint(body.listing);
          say(card.querySelector("[data-used-card-msg]"), what === "sold" ? t("closed_sold") : t("closed_removed"));
          track("listing_closed", { code: listing.code, action: what });
          load();
          if (thenSell) { closeSheet(manageDialog); openSell(); }
        }).catch(function (error) {
          go.disabled = false;
          if (error.status === 401) { loadManage(); return; }
          say(card.querySelector("[data-used-card-msg]"), problem(error, "manage_edit_error"));
        });
        return;
      }
      if (event.target.closest("[data-used-relist]")) { closeSheet(manageDialog); openSell(); }
    });
    paint(listing);
    return card;
  }

  // ---------- Page events ----------
  grid.addEventListener("click", function (event) {
    var link = event.target.closest("[data-used-open]");
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    openDetail(link.getAttribute("data-used-open"));
  });
  if (detail) detail.addEventListener("click", function (event) {
    if (event.target.closest("[data-used-detail-retry]")) { openDetail(state.query.code, true); return; }
    var thumb = event.target.closest("[data-used-thumb]");
    if (!thumb) return;
    var stage = detailBody.querySelector("[data-used-stage]");
    if (stage) stage.src = safeSrc(thumb.getAttribute("data-used-thumb"));
    detailBody.querySelectorAll("[data-used-thumb]").forEach(function (el) { el.classList.toggle("is-on", el === thumb); el.setAttribute("aria-pressed", el === thumb ? "true" : "false"); });
  });
  root.addEventListener("click", function (event) {
    if (event.target.closest("[data-used-sell]")) { event.preventDefault(); openSell(); return; }
    if (event.target.closest("[data-used-manage]")) { event.preventDefault(); openManage(); return; }
    if (event.target.closest("[data-used-terms-link]")) { event.preventDefault(); openTerms(); return; }
    if (event.target.closest("[data-used-terms-retry]")) { loadTerms(); renderTerms(); return; }
    if (event.target.closest("[data-used-filter-toggle]")) {
      filtersOpen = !filtersOpen;
      filterToggle.setAttribute("aria-expanded", filtersOpen ? "true" : "false");
      render(); return;
    }
    var chip = event.target.closest("[data-used-chip]");
    if (chip && root.contains(chip)) { state.query[chip.getAttribute("data-used-chip")] = chip.getAttribute("data-value") || ""; applyFilters(); return; }
    if (event.target.closest("[data-used-retry]")) { load(); return; }
    if (event.target.closest("[data-used-reset]")) {
      window.clearTimeout(filterTimer);
      FILTERS.forEach(function (key) { state.query[key] = key === "sort" ? "newest" : ""; });
      syncFilters(); writeQuery(); load();
    }
  });
  [cityInput, priceMin, priceMax].forEach(function (input) {
    if (input) input.addEventListener("input", function () { window.clearTimeout(filterTimer); filterTimer = window.setTimeout(applyFilters, 350); });
  });
  [sortSelect, conditionSelect].forEach(function (select) { if (select) select.addEventListener("change", applyFilters); });
  window.addEventListener("popstate", function () {
    window.clearTimeout(filterTimer);
    state.query = readQuery(); syncFilters(); load();
    if (state.query.code) openDetail(state.query.code, true);
    else { detailRequest += 1; closeSheet(detail); }
  });
  window.addEventListener("resize", syncToolbar);

  // ---------- Start ----------
  syncFilters();
  loadTerms();
  load();
  var params = new URLSearchParams(window.location.search);
  var hash = (window.location.hash || "").toLowerCase();
  if (manageToken || params.get("manage") === "1" || hash === "#manage") openManage();
  else if (params.get("sell") === "1" || hash === "#sell") openSell();
  else if (state.query.code) openDetail(state.query.code, true);
})();
